export default function AboutHero() {
  return (
    <section className="relative w-full min-h-[420px] md:min-h-[500px] flex items-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Abstract%20warm%20elegant%20office%20library%20space%20with%20bookshelves%20and%20soft%20natural%20lighting%2C%20cream%20beige%20and%20warm%20wood%20tones%2C%20minimal%20aesthetic%2C%20editorial%20photography%20with%20gentle%20atmosphere&width=1800&height=700&seq=about-hero-bg&orientation=landscape"
          alt=""
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/25 via-black/15 to-black/30"></div>
      </div>
      <div className="relative z-10 w-full max-w-7xl mx-auto px-4 md:px-6 py-16 md:py-20">
        <div className="max-w-2xl">
          <div className="inline-flex items-center gap-2 px-4 py-2 bg-white/20 backdrop-blur-sm rounded-full text-white text-sm mb-6">
            <i className="ri-building-line"></i>
            <span>始于2020 · 专注精品内容</span>
          </div>
          <h1 className="text-3xl md:text-4xl lg:text-5xl font-heading font-bold text-white leading-tight mb-5">
            关于精品一区
          </h1>
          <p className="text-lg text-white/85 leading-relaxed">
            致力于为追求品质生活的读者提供最有价值的精选内容，我们相信好的内容值得被更多人看见。
          </p>
        </div>
      </div>
      <div className="absolute bottom-0 left-0 right-0 h-24 bg-gradient-to-t from-background-50 to-transparent"></div>
    </section>
  );
}